import { persistor } from '@shared/redux';
import { Routes } from '@shared/constants/routes';
type HardResetOptions = {
  broadcast?: () => void;
};

export const hardResetAuth = async ({ broadcast }: HardResetOptions = {}) => {
  if (broadcast) {
    broadcast();
  }

  try {
    await persistor?.pause?.();
  } catch {}

  try {
    await persistor?.purge?.();
  } catch {}

  try {
    localStorage.clear();
  } catch {}

  try {
    sessionStorage.clear();
  } catch {}

  if (typeof window !== 'undefined') {
    window.location.assign(Routes.authentication.signIn);
  }
};
